export const SESSION_STORAGE_KEY_GOOGLE_CLICK_IDS = "googleClickIds";
